import { FAST_CHECKOUT_CYCLES, FAST_CHECKOUT_PAYMENT_METHODS, FAST_CHECKOUT_PRODUCTS_BR } from '@/pages/FastCheckout/FastCheckout.enum.jsx';
import React from 'react';


export default {
  backButton: 'Voltar',
  cartTitle: 'Carrinho',
  resumeTitle: 'Resumo da compra',
  product: 'Produto',
  renewal: 'Próxima renovação ',
  total: 'Total da compra: ',
  value: 'Valor: ',
  discountTag: 'Desconto',
  ctaPurchase: 'Finalizar compra',
  securityReminder: 'Transação segura e criptografada',
  confirmPaymentLoading: 'Estamos preparando tudo para você...',
  errorToast: 'Ocorreu um erro inesperado, tente novamente mais tarde',
  purchaseErrorToast: {
    title: 'Seu pagamento não foi concluído',
    description: 'Confira os dados do cartão, o saldo ou tente com outro cartão de crédito.',
  },
  paymentTitle: 'Pagamento',
  emailTitle: 'E-mail cadastrado',
  dataTitle: 'Dados pessoais',
  renewalSamePaymentMethod: (
    <>
      <span>Renovação Automática: </span>
      Esse produto será renovado automaticamente no cartão de crédito cadastrado. Você pode cancelar a qualquer hora em assinaturas.
    </>
  ),
  renewalSamePaymentMethodInTrial: (
    <>
      <span>Importante: </span>
      Só cobramos no cartão depois dos 7 dias de teste. Vamos te avisar no seu e-mail antes do fim do período de teste.
    </>
  ),
  taxToolTip: {
    title: 'Impostos e tarifas',
    description: 'A aplicação do imposto IVA/IVA pode ser identificada nos tipos de compras:',
    topics: [
      {
        id: 1,
        text: 'Compras realizadas por pessoas físicas no site da HostGator Argentina',
      },
      {
        id: 2,
        text: 'As ocorrências nos sites da HostGator por pessoas residentes no território europeu',
      },
    ],
  },
  personalDataForm: {
    fields: {
      foreigner: {
        label: 'Sou estrangeiro',
      },
      nacionality: {
        label: 'Nacionalidade',
      },
      document: {
        label: 'CPF OU CNPJ',
      },
      birthDate: {
        label: 'Data de nascimento',
      },
      name: {
        label: 'Nome completo',
      },
      companyName: {
        label: 'Razão Social',
      },
      companyResponsible: {
        label: 'Representante legal',
      },
      telephone: {
        label: 'Celular',
      },
      country: {
        label: 'País de residência',
      },
      cep: {
        label: 'Cep',
      },
      postalCode: {
        label: 'Código postal',
      },
      state: {
        label: 'Estado',
      },
      city: {
        label: 'Cidade',
      },
      address: {
        label: 'Endereço',
      },
      block: {
        label: 'Bairro',
      },
      complement: {
        label: 'Número e complemento',
      },
    },
    dontKnowMyCep: {
      label: 'Não sei meu Cep',
    },
  },
  cycles: {
    [FAST_CHECKOUT_CYCLES.MONTHLY]: 'Plano mensal',
    [FAST_CHECKOUT_CYCLES.QUARTERLY]: 'Plano trimestral',
    [FAST_CHECKOUT_CYCLES.SEMIANNUALLY]: 'Plano semestral',
    [FAST_CHECKOUT_CYCLES.ANNUALLY]: 'Plano anual',
  },
  paymentMethods: {
    [FAST_CHECKOUT_PAYMENT_METHODS.CREDIT_CARD]: {
      label: 'Preencha os dados do cartão de crédito',
      ccAlreadyRegistered: 'Cartão cadastrado',
      newCC: 'Novo Cartão de Crédito',
      alreadyRegisteredTitle: 'Informações do cartão cadastrado',
      nextPayment: 'Próximo pagamento',
      expire: 'Vencimento: ',
      dateGrouper: 'de',
    },
  },
  successPage: {
    title: 'Pagamento concluído',
    description: (
      <>
        Parabéns! Seu pagamento foi realizado.
        <br />
        Em breve, você receberá um e-mail de confirmação.
      </>
    ),
    ctaLabel: 'Ok, entendi',
  },
  products: {
    [FAST_CHECKOUT_PRODUCTS_BR.GATOR_BACKUP_CORE]: {
      name: 'Gator Backup Core',
      defaultCycle: FAST_CHECKOUT_CYCLES.ANNUALLY,
      defaultPaymentMethod: FAST_CHECKOUT_PAYMENT_METHODS.CREDIT_CARD,
      icon: '',
      isTrial: false,
    },
    [FAST_CHECKOUT_PRODUCTS_BR.GATOR_BACKUP_PLUS]: {
      name: 'Gator Backup Plus',
      defaultCycle: FAST_CHECKOUT_CYCLES.ANNUALLY,
      defaultPaymentMethod: FAST_CHECKOUT_PAYMENT_METHODS.CREDIT_CARD,
      icon: '',
      isTrial: false,
    },
    [FAST_CHECKOUT_PRODUCTS_BR.GATOR_BACKUP_ADVANCED]: {
      name: 'Gator Backup Advanced',
      defaultCycle: FAST_CHECKOUT_CYCLES.ANNUALLY,
      defaultPaymentMethod: FAST_CHECKOUT_PAYMENT_METHODS.CREDIT_CARD,
      icon: '',
      isTrial: false,
    },
    [FAST_CHECKOUT_PRODUCTS_BR.GATOR_BACKUP_MAX]: {
      name: 'Gator Backup Max',
      defaultCycle: FAST_CHECKOUT_CYCLES.ANNUALLY,
      defaultPaymentMethod: FAST_CHECKOUT_PAYMENT_METHODS.CREDIT_CARD,
      icon: '',
      isTrial: false,
    },
  },
};
